/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderStyle: {
  name: 'border-style';
  data: string;
} = {
  name: 'border-style',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"/></svg>`
};
